import { TicketActivityAction, TicketActivityActionsNames } from "./actions";

export type ITicketActivityState = {
  typing: Record<string, Record<string, boolean>>;
  viewing: Record<string, Record<string, boolean>>;
};

export const initialState: ITicketActivityState = {
  typing: {},
  viewing: {},
};

function addActivityEntry(
  collection: Record<string, Record<string, boolean>>,
  ticketID: string,
  agentID: string
): Record<string, Record<string, boolean>> {
  const entries = collection[ticketID] || {};
  return { ...collection, [ticketID]: { ...entries, [agentID]: true } };
}

function deleteActivityEntry(
  collection: Record<string, Record<string, boolean>>,
  ticketID: string,
  agentID: string
): Record<string, Record<string, boolean>> {
  const entries = { ...collection[ticketID] };
  delete entries[agentID];

  return { ...collection, [ticketID]: entries };
}

export default function ticketActivityReducer(
  state = initialState,
  action: TicketActivityAction
): ITicketActivityState {
  switch (action.type) {
    case TicketActivityActionsNames.SET_AGENT_TYPING: {
      const { ticketID, agentID } = action.payload;
      return { ...state, typing: addActivityEntry(state.typing, ticketID, agentID) };
    }

    case TicketActivityActionsNames.SET_AGENT_VIEWING: {
      const { ticketID, agentID } = action.payload;
      return { ...state, viewing: addActivityEntry(state.viewing, ticketID, agentID) };
    }

    case TicketActivityActionsNames.UNSET_AGENT_VIEWING: {
      const { ticketID, agentID } = action.payload;
      return { ...state, viewing: deleteActivityEntry(state.viewing, ticketID, agentID) };
    }

    case TicketActivityActionsNames.UNSET_AGENT_TYPING: {
      const { ticketID, agentID } = action.payload;
      return { ...state, typing: deleteActivityEntry(state.typing, ticketID, agentID) };
    }

    default:
      return state;
  }
}
